module.exports = __webpack_public_path__ + "static/map-f5aa246f972669736ea81823f9417b54.png";